import { IonIcon } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { timeIcon } from "@/lib/icons/time.icon";

interface BreakTimeButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export function BreakTimeButton({
  onClick,
  isLoading = false,
  disabled = false,
}: BreakTimeButtonProps) {
  const { t } = useTranslation();

  return (
    <Button expand="block" onClick={onClick} disabled={disabled || isLoading} className="w-full">
      <div className="flex items-center gap-2">
        <IonIcon icon={timeIcon} className="size-5" />
        {isLoading ? t("common:loading") : t("shift:break-time.clock")}
      </div>
    </Button>
  );
}
